
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer une carte de visite impactante pour un commercial",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez nos conseils pour créer une carte de visite de commercial percutante et mémorable, afin de laisser une impression durable sur vos prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer votre carte de visite de commercial",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous donne des conseils et astuces pour la création de votre carte de visite de commercial !",
        },
      ],
    };
  },
};
